function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define("YWWriterIconsReact.TriangleDown", ["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.React);
    global.YWWriterIconsReact = global.YWWriterIconsReact || {};
    global.YWWriterIconsReact["TriangleDown"] = mod.exports.default;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (exports, React) {
  "use strict";

  var TriangleDown = props => /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.5962 16.7843C11.795 17.0719 12.205 17.0719 12.4038 16.7843L17.9048 8.8252C18.1427 8.481 17.9074 8 17.501 8H6.49897C6.09265 8 5.85728 8.481 6.09518 8.8252L11.5962 16.7843Z",
    fill: "currentColor"
  }));
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = TriangleDown;
});